// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/event_plan.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/event_plan.proto.
 */
export const file_cortado_v1_event_plan: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * EventAddon is an add-on the customer accepted on the quote that booked the
 * event: a quote line item created from an add-on offer.
 *
 * @generated from message cortado.v1.EventAddon
 */
export type EventAddon = Message<"cortado.v1.EventAddon"> & {
  /**
   * @generated from field: string line_item_id = 1;
   */
  lineItemId: string;

  /**
   * @generated from field: string addon_offer_id = 2;
   */
  addonOfferId: string;

  /**
   * The catalog item the offer was made from, when it still had one.
   *
   * @generated from field: optional string catalog_item_id = 3;
   */
  catalogItemId?: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * Quantity on the quote line, in `unit`.
   *
   * @generated from field: double quantity = 6;
   */
  quantity: number;

  /**
   * Catalog unit as stored on the line ("PerUnit", "PerEvent", "PerHour", ...).
   *
   * @generated from field: string unit = 7;
   */
  unit: string;

  /**
   * Whole units to pack: the quantity rounded up for per-unit add-ons, else 1.
   *
   * @generated from field: int32 pack_quantity = 8;
   */
  packQuantity: number;
};

/**
 * Describes the message cortado.v1.EventAddon.
 * Use `create(EventAddonSchema)` to create a new message.
 */
export const EventAddonSchema: GenMessage<EventAddon> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 0);

/**
 * @generated from message cortado.v1.ListEventAddonsRequest
 */
export type ListEventAddonsRequest = Message<"cortado.v1.ListEventAddonsRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.ListEventAddonsRequest.
 * Use `create(ListEventAddonsRequestSchema)` to create a new message.
 */
export const ListEventAddonsRequestSchema: GenMessage<ListEventAddonsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 1);

/**
 * @generated from message cortado.v1.ListEventAddonsResponse
 */
export type ListEventAddonsResponse = Message<"cortado.v1.ListEventAddonsResponse"> & {
  /**
   * The quote event this event was booked from. Unset for events not booked
   * from a quote (or booked before the link existed and not backfilled); such
   * events have no add-ons.
   *
   * @generated from field: optional string source_quote_revision_event_id = 1;
   */
  sourceQuoteRevisionEventId?: string;

  /**
   * @generated from field: repeated cortado.v1.EventAddon addons = 2;
   */
  addons: EventAddon[];
};

/**
 * Describes the message cortado.v1.ListEventAddonsResponse.
 * Use `create(ListEventAddonsResponseSchema)` to create a new message.
 */
export const ListEventAddonsResponseSchema: GenMessage<ListEventAddonsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 2);

/**
 * @generated from message cortado.v1.EventInventoryDemand
 */
export type EventInventoryDemand = Message<"cortado.v1.EventInventoryDemand"> & {
  /**
   * @generated from field: cortado.v1.InventoryDemandDriverEnum driver = 1;
   */
  driver: InventoryDemandDriverEnum;

  /**
   * Guest count after rounding up to the org's increment and minimum.
   *
   * @generated from field: int32 snapped_guests = 2;
   */
  snappedGuests: number;

  /**
   * Total drinks including the buffer percentage.
   *
   * @generated from field: int32 total_drinks = 3;
   */
  totalDrinks: number;

  /**
   * Drinks the team can serve in the event window; 0 when unknown.
   *
   * @generated from field: double capacity = 4;
   */
  capacity: number;

  /**
   * Guest-driven demand exceeds capacity.
   *
   * @generated from field: bool over_capacity = 5;
   */
  overCapacity: boolean;
};

/**
 * Describes the message cortado.v1.EventInventoryDemand.
 * Use `create(EventInventoryDemandSchema)` to create a new message.
 */
export const EventInventoryDemandSchema: GenMessage<EventInventoryDemand> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 3);

/**
 * @generated from message cortado.v1.EventPackingLine
 */
export type EventPackingLine = Message<"cortado.v1.EventPackingLine"> & {
  /**
   * Stable across regenerations while the input that made the line exists.
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: cortado.v1.PackingLineSourceEnum source = 2;
   */
  source: PackingLineSourceEnum;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Trimmed category; empty for uncategorized computed lines. Add-on lines
   * use "Add-ons".
   *
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * @generated from field: string unit_name = 5;
   */
  unitName: string;

  /**
   * @generated from field: string unit_size = 6;
   */
  unitSize: string;

  /**
   * @generated from field: int32 quantity = 7;
   */
  quantity: number;

  /**
   * Set on add-on lines.
   *
   * @generated from field: optional string addon_offer_id = 8;
   */
  addonOfferId?: string;

  /**
   * @generated from field: optional string catalog_item_id = 9;
   */
  catalogItemId?: string;
};

/**
 * Describes the message cortado.v1.EventPackingLine.
 * Use `create(EventPackingLineSchema)` to create a new message.
 */
export const EventPackingLineSchema: GenMessage<EventPackingLine> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 4);

/**
 * EventPlanInputChange is one input that differs from what a saved packing
 * list or timeline was generated from, worded for the stale notice
 * ("Guests changed from 75 to 90").
 *
 * @generated from message cortado.v1.EventPlanInputChange
 */
export type EventPlanInputChange = Message<"cortado.v1.EventPlanInputChange"> & {
  /**
   * Stable identifier, e.g. "guests", "cart_count", "addons".
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * Display values; empty when the change has no single value to show.
   *
   * @generated from field: string from_value = 3;
   */
  fromValue: string;

  /**
   * @generated from field: string to_value = 4;
   */
  toValue: string;
};

/**
 * Describes the message cortado.v1.EventPlanInputChange.
 * Use `create(EventPlanInputChangeSchema)` to create a new message.
 */
export const EventPlanInputChangeSchema: GenMessage<EventPlanInputChange> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 5);

/**
 * @generated from message cortado.v1.PreviewEventInventoryRequest
 */
export type PreviewEventInventoryRequest = Message<"cortado.v1.PreviewEventInventoryRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.PreviewEventInventoryRequest.
 * Use `create(PreviewEventInventoryRequestSchema)` to create a new message.
 */
export const PreviewEventInventoryRequestSchema: GenMessage<PreviewEventInventoryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 6);

/**
 * PreviewEventInventoryResponse is the packing list the event's current
 * inputs produce. Nothing is saved.
 *
 * @generated from message cortado.v1.PreviewEventInventoryResponse
 */
export type PreviewEventInventoryResponse = Message<"cortado.v1.PreviewEventInventoryResponse"> & {
  /**
   * @generated from field: cortado.v1.EventInventoryDemand demand = 1;
   */
  demand?: EventInventoryDemand;

  /**
   * Org items in settings order, then add-ons in quote line order.
   *
   * @generated from field: repeated cortado.v1.EventPackingLine lines = 2;
   */
  lines: EventPackingLine[];

  /**
   * Fingerprint of the inputs, comparable with a saved list's fingerprint.
   *
   * @generated from field: string inputs_fingerprint = 3;
   */
  inputsFingerprint: string;
};

/**
 * Describes the message cortado.v1.PreviewEventInventoryResponse.
 * Use `create(PreviewEventInventoryResponseSchema)` to create a new message.
 */
export const PreviewEventInventoryResponseSchema: GenMessage<PreviewEventInventoryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 7);

/**
 * @generated from message cortado.v1.EventTimelineBlock
 */
export type EventTimelineBlock = Message<"cortado.v1.EventTimelineBlock"> & {
  /**
   * @generated from field: cortado.v1.TimelineBlockKindEnum kind = 1;
   */
  kind: TimelineBlockKindEnum;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: google.protobuf.Timestamp start = 3;
   */
  start?: Timestamp;

  /**
   * @generated from field: int32 minutes = 4;
   */
  minutes: number;

  /**
   * Explains an adjustment, e.g. "+15m for 2 carts" on prep.
   *
   * @generated from field: string note = 5;
   */
  note: string;

  /**
   * Calendar days from the event's start date, in `timezone`.
   *
   * @generated from field: int32 day_offset = 6;
   */
  dayOffset: number;

  /**
   * Saved block ID (event_timeline.proto). Empty in previews.
   *
   * @generated from field: string id = 7;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.EventTimelineBlock.
 * Use `create(EventTimelineBlockSchema)` to create a new message.
 */
export const EventTimelineBlockSchema: GenMessage<EventTimelineBlock> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 8);

/**
 * @generated from message cortado.v1.PreviewEventTimelineRequest
 */
export type PreviewEventTimelineRequest = Message<"cortado.v1.PreviewEventTimelineRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message cortado.v1.PreviewEventTimelineRequest.
 * Use `create(PreviewEventTimelineRequestSchema)` to create a new message.
 */
export const PreviewEventTimelineRequestSchema: GenMessage<PreviewEventTimelineRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 9);

/**
 * PreviewEventTimelineResponse is the run of show the event's current inputs
 * produce. Nothing is saved. Requires an event date (FailedPrecondition
 * otherwise).
 *
 * @generated from message cortado.v1.PreviewEventTimelineResponse
 */
export type PreviewEventTimelineResponse = Message<"cortado.v1.PreviewEventTimelineResponse"> & {
  /**
   * Prep, drive to, setup, event, teardown, drive back; each starts where the
   * previous one ends.
   *
   * @generated from field: repeated cortado.v1.EventTimelineBlock blocks = 1;
   */
  blocks: EventTimelineBlock[];

  /**
   * False when there is no drive time (no event location, no org address, or
   * the directions lookup failed); drive blocks are then 0 minutes.
   *
   * @generated from field: bool drive_time_known = 2;
   */
  driveTimeKnown: boolean;

  /**
   * Rounded one-way drive time used for both drive blocks.
   *
   * @generated from field: int32 drive_minutes = 3;
   */
  driveMinutes: number;

  /**
   * IANA zone the day offsets are computed in: the event's, else the org's,
   * else UTC.
   *
   * @generated from field: string timezone = 4;
   */
  timezone: string;

  /**
   * @generated from field: string inputs_fingerprint = 5;
   */
  inputsFingerprint: string;
};

/**
 * Describes the message cortado.v1.PreviewEventTimelineResponse.
 * Use `create(PreviewEventTimelineResponseSchema)` to create a new message.
 */
export const PreviewEventTimelineResponseSchema: GenMessage<PreviewEventTimelineResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_event_plan, 10);

/**
 * @generated from enum cortado.v1.InventoryDemandDriverEnum
 */
export enum InventoryDemandDriverEnum {
  /**
   * @generated from enum value: INVENTORY_DEMAND_DRIVER_UNSPECIFIED = 0;
   */
  INVENTORY_DEMAND_DRIVER_UNSPECIFIED = 0,

  /**
   * Guests x drinks per guest.
   *
   * @generated from enum value: INVENTORY_DEMAND_DRIVER_GUESTS = 1;
   */
  INVENTORY_DEMAND_DRIVER_GUESTS = 1,

  /**
   * Max drinks per hour x event length.
   *
   * @generated from enum value: INVENTORY_DEMAND_DRIVER_HOURS = 2;
   */
  INVENTORY_DEMAND_DRIVER_HOURS = 2,
}

/**
 * Describes the enum cortado.v1.InventoryDemandDriverEnum.
 */
export const InventoryDemandDriverEnumSchema: GenEnum<InventoryDemandDriverEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_event_plan, 0);

/**
 * @generated from enum cortado.v1.PackingLineSourceEnum
 */
export enum PackingLineSourceEnum {
  /**
   * @generated from enum value: PACKING_LINE_SOURCE_UNSPECIFIED = 0;
   */
  PACKING_LINE_SOURCE_UNSPECIFIED = 0,

  /**
   * From the org's inventory settings.
   *
   * @generated from enum value: PACKING_LINE_SOURCE_COMPUTED = 1;
   */
  PACKING_LINE_SOURCE_COMPUTED = 1,

  /**
   * From an accepted quote add-on.
   *
   * @generated from enum value: PACKING_LINE_SOURCE_ADDON = 2;
   */
  PACKING_LINE_SOURCE_ADDON = 2,
}

/**
 * Describes the enum cortado.v1.PackingLineSourceEnum.
 */
export const PackingLineSourceEnumSchema: GenEnum<PackingLineSourceEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_event_plan, 1);

/**
 * @generated from enum cortado.v1.TimelineBlockKindEnum
 */
export enum TimelineBlockKindEnum {
  /**
   * @generated from enum value: TIMELINE_BLOCK_KIND_UNSPECIFIED = 0;
   */
  TIMELINE_BLOCK_KIND_UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIMELINE_BLOCK_KIND_PREP = 1;
   */
  TIMELINE_BLOCK_KIND_PREP = 1,

  /**
   * @generated from enum value: TIMELINE_BLOCK_KIND_DRIVE_TO = 2;
   */
  TIMELINE_BLOCK_KIND_DRIVE_TO = 2,

  /**
   * @generated from enum value: TIMELINE_BLOCK_KIND_SETUP = 3;
   */
  TIMELINE_BLOCK_KIND_SETUP = 3,

  /**
   * @generated from enum value: TIMELINE_BLOCK_KIND_EVENT = 4;
   */
  TIMELINE_BLOCK_KIND_EVENT = 4,

  /**
   * @generated from enum value: TIMELINE_BLOCK_KIND_TEARDOWN = 5;
   */
  TIMELINE_BLOCK_KIND_TEARDOWN = 5,

  /**
   * @generated from enum value: TIMELINE_BLOCK_KIND_DRIVE_BACK = 6;
   */
  TIMELINE_BLOCK_KIND_DRIVE_BACK = 6,

  /**
   * A block someone added to a saved timeline.
   *
   * @generated from enum value: TIMELINE_BLOCK_KIND_CUSTOM = 7;
   */
  TIMELINE_BLOCK_KIND_CUSTOM = 7,
}

/**
 * Describes the enum cortado.v1.TimelineBlockKindEnum.
 */
export const TimelineBlockKindEnumSchema: GenEnum<TimelineBlockKindEnum> = /*@__PURE__*/
  enumDesc(file_cortado_v1_event_plan, 2);

